import requests from '../../../../redux/reducer/requests';
import content from '../../../../redux/reducer/content';
import { useDispatch } from 'react-redux';

export default function useBeautyCallbacks() {
  const dispatch = useDispatch();

  return {
    beautyProcedure: (id) => dispatch(requests.thunks.beautyProcedure(id)),
    setIsBath: (isBath) => dispatch(content.actions.setIsBath(isBath)),
    getBeautyRoutine: () => dispatch(requests.thunks.getBeautyRoutine()),
    endBeautyRoutine: (data) => dispatch(requests.thunks.endBeautyRoutine(data)),
  };
}
